import { render, staticRenderFns } from "./ExclusionTable.vue?vue&type=template&id=ec96e9fe&scoped=true"
import script from "./ExclusionTable.vue?vue&type=script&lang=js"
export * from "./ExclusionTable.vue?vue&type=script&lang=js"
import style0 from "./ExclusionTable.vue?vue&type=style&index=0&id=ec96e9fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec96e9fe",
  null
  
)

export default component.exports